import { useHistory, useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useConfirm } from "material-ui-confirm";
import styled from "styled-components";

import { PaneListButton, PaneListItemHoverActions } from "src/components/PaneListButton";
import { LEZ, Scenario } from "src/types";
import { useLEZDeleteMutation } from "src/hooks";
import { IsEnabled } from "./permissions";

interface Props {
  scenario: Scenario;
  lez: LEZ;
}

export function LEZListItem(props: Props) {
  const { scenario, lez } = props;

  const params = useParams<{
    caseId: string;
    scenarioId: string;
    lezId?: string;
  }>();
  const history = useHistory();
  const confirm = useConfirm();

  const { t } = useTranslation();
  const deleteMutation = useLEZDeleteMutation(params.scenarioId, lez.id);

  /**
   * Functions
   */
  function handleDelete(lez: LEZ) {
    confirm({
      title: t("label.areYouSure"),
      description: t("confirm.deleteLEZ"),
      confirmationButtonProps: { autoFocus: true },
    }).then(() => {
      deleteMutation.mutate();

      // if the deleted item is being viewed, return to list of items
      if (params.lezId === lez.id.toString()) {
        history.push(`/cases/${params.caseId}/scenarios/${params.scenarioId}/lezs`);
      }
    });
  }

  return render();

  function render() {
    if (!scenario) return null;

    return (
      <Styles>
        <PaneListButton
          to={`/cases/${params.caseId}/scenarios/${params.scenarioId}/lezs/${lez.id}`}
          className="list-item"
        >
          <div className="name">{lez.name}</div>

          <PaneListItemHoverActions>
            <IsEnabled permission={scenario.permissions.updateLEZ}>
              <IconButton
                aria-label="delete LEZ"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  handleDelete(lez);
                }}
                size="large"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </IsEnabled>
          </PaneListItemHoverActions>
        </PaneListButton>
      </Styles>
    );
  }
}

const Styles = styled.div`
  .list-item {
    justify-content: space-between;
  }
`;
